import { ColorRecipeModel } from '../edit/models/color-recipe.model';
import { Store } from '@ngxs/store';
import { EngineState } from './state/engine.state';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { EngineService } from './engine.service';
import { PaintPresetOriginal, PaintPresetFade } from './models/paint-presets.const';
import { ObjectColor } from '../shared/object-color';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
import * as i2 from "../../lib/graph/graph.service";
import * as i3 from "./engine.service";
export class PaintService {
    constructor(store, graphService, engineService) {
        this.store = store;
        this.graphService = graphService;
        this.engineService = engineService;
        this.highlightDisabled = false;
    }
    colorObject(objectId, params) {
        const humanObject = Human.scene.objects[objectId];
        if (humanObject instanceof Human.scene.Object) {
            // to clear or not to clear, that is the question
            // apply mod properties that are not default
            if (params.hasOwnProperty('tintColor')) {
                humanObject.setTintColor(params.tintColor);
            }
            if (params.hasOwnProperty('saturation')) {
                humanObject.setSaturation(params.saturation);
            }
            if (params.hasOwnProperty('brightness')) {
                humanObject.setBrightness(params.brightness);
            }
            if (params.hasOwnProperty('contrast')) {
                humanObject.setContrast(params.contrast);
            }
            if (params.hasOwnProperty('opacity')) {
                humanObject.setOpacity(params.opacity);
            }
        }
    }
    getColor(objectId) {
        return ObjectColor.getColorRecipe(Human, objectId);
    }
    uncolorObject(objectId) {
        const object = Human.scene.objects[objectId];
        if (object instanceof Human.scene.Object) {
            object.clearColorModifiers();
            object.clearOpacityModifiers();
        }
    }
    unpaint(node) {
        // relay color mods to each engine leaf
        const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        this.graphService.getLeafDescendants(viewGraph, node.id).forEach((id) => {
            this.engineService.getObjects(id).forEach((humanObjectId) => {
                const humanObject = Human.scene.objects[humanObjectId];
                if (humanObject instanceof Human.scene.Object) {
                    // reset object mod properties
                    humanObject.clearColorModProperties();
                    humanObject.clearOpacityModProperties();
                }
            });
        });
    }
    paint(node, recipe) {
        // relay color mods to each engine leaf
        const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        const engineRecipe = ColorRecipeModel.toEngine(recipe);
        this.graphService.getLeafDescendants(viewGraph, node.id).forEach((id) => {
            this.engineService.getObjects(id).forEach((humanObjectId) => {
                this.uncolorObject(humanObjectId);
                this.colorObject(humanObjectId, engineRecipe);
            });
        });
    }
    highlight(node, highlight) {
        // allow un-highlight if highlight is disabled
        if (this.highlightDisabled === false || highlight === false) {
            // relay highlight to each engine leaf
            const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            this.graphService.getLeafDescendants(viewGraph, node.id).forEach((id) => {
                this.engineService.getObjects(id).forEach((humanObjectId) => {
                    const humanObject = Human.scene.objects[humanObjectId];
                    if (humanObject instanceof Human.scene.Object) {
                        humanObject.setHighlight(highlight);
                    }
                });
            });
        }
    }
    xRay(node, xRay) {
        const object = Human.scene.objects[node.id];
        object.setXRay(xRay);
    }
    paintAll(nodes, recipe) {
        nodes.forEach(node => {
            this.paint(node, recipe);
        });
    }
    highlightAll(nodes, highlight) {
        nodes.forEach(node => {
            this.highlight(node, highlight);
        });
    }
    inverseXRay(nodes, viewGraph) {
        const nodeIds = nodes.map(node => node.id);
        const inverseNodeIds = this.graphService.getInverseSelection(viewGraph, nodeIds);
        const inverseNodes = this.graphService.getNodes(viewGraph, inverseNodeIds);
        this.paintAll(inverseNodes, PaintPresetFade.recipe);
        this.paintAll(nodes, PaintPresetOriginal.recipe);
    }
    disableHighlight() {
        this.highlightDisabled = true;
    }
    enableHighlight() {
        this.highlightDisabled = false;
    }
}
PaintService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PaintService_Factory() { return new PaintService(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.BdGraphService), i0.ɵɵinject(i3.EngineService)); }, token: PaintService, providedIn: "root" });
